<template>
    <div
        v-bind="floatingProps"
        :class="[
            'z-20 flex flex-col items-stretch border border-gray-300 bg-white p-1 shadow-md',
            marginClass
        ]"
    >
        <slot />
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, toRef } from 'vue'
import { autoUpdate, flip, shift, size, useFloating } from '@floating-ui/vue'

export default defineComponent({
    name: 'PopupMenuRender',

    props: {
        anchorRef: {
            type: Object,
            required: true
        },
        menuId: {
            type: String,
            required: true
        },
        anchorId: {
            type: String,
            required: true
        },
        marginClass: {
            type: String,
            default: ''
        }
    },

    setup(props) {
        const anchorRef = toRef(props, 'anchorRef')
        const floatingRef = ref()
        const { floatingStyles } = useFloating(anchorRef, floatingRef, {
            transform: false,
            whileElementsMounted: autoUpdate,
            placement: 'bottom-start',
            middleware: [
                flip(),
                shift(),
                size({
                    apply({ availableWidth, availableHeight, elements }) {
                        // Limit the floating element's height to available space
                        Object.assign(elements.floating.style, {
                            maxWidth: `${availableWidth}px`,
                            maxHeight: `${availableHeight}px`,
                            overflowY: 'auto',
                            overflowX: 'auto' // or 'hidden' if you only want vertical scroll
                        })
                    }
                })
            ]
        })

        const floatingProps = computed(() => ({
            ref: floatingRef,
            id: props.menuId,
            role: 'menu',
            'aria-labelledby': props.anchorId,
            style: floatingStyles.value
        }))

        onMounted(() => {
            const focusNode = floatingRef.value?.querySelector(
                'input:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly])'
            )
            if (focusNode !== null) {
                focusNode?.select()
            }
        })

        return {
            floatingProps
        }
    }
})
</script>
